
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors, createListSliceSelectors } from '@aston/foundation';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { FeatureName } from './feature';
import { ISubsidiaryDetailState } from './state';

export const selectState: MemoizedSelector<object, ISubsidiaryDetailState> = createFeatureSelector<ISubsidiaryDetailState>(FeatureName);

export const getCurrentSubsidiaryId = (state: ISubsidiaryDetailState): number => state.currentSubsidiaryId;
export const selectCurrentSubsidiaryId = createSelector(selectState, state => getCurrentSubsidiaryId(state));

export const getActiveModal = (state: ISubsidiaryDetailState): NgbModalRef => state.activeModal;
export const selectActiveModal = createSelector(selectState, state => getActiveModal(state));

export const {
	selectEntity: selectSubsidiary,
	selectIsLoading: selectSubsidiaryIsLoading,
	selectError: selectSubsidiaryError
} = createEntitySliceSelectors(createSelector(selectState, state => state.currentSubsidiary));

export const {
	selectEntity: selectSubsidiaryForm,
	selectIsLoading: selectSubsidiaryFormIsLoading,
	selectError: selectSubsidiaryFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryForm));

export const {
	selectSlice: selectUsersListSlice,
	selectList: selectUsersList,
	selectFilters: selectUsersFilters,
	selectError: selectUsersError,
	selectIsLoading: selectUsersIsLoading,
	selectPaging: selectUsersListPaging,
} = createListSliceSelectors(createSelector(selectState, (state) => state.usersList));

export const {
	selectEntity: selectUserStatus,
	selectIsLoading: selectUserStatusIsLoading,
	selectError: selectUserStatusError
} = createEntitySliceSelectors(createSelector(selectState, state => state.transientUserStatus));

export const {
	selectEntity: selectSubsidiaryRole,
	selectIsLoading: selectSubsidiaryRoleIsLoading,
	selectError: selectSubsidiaryRoleError
} = createEntitySliceSelectors(createSelector(selectState, state => state.transientSubsidiaryRole));

export const getSubsidiaryFormIsEditing = (state: ISubsidiaryDetailState): boolean => state.subsidiaryFormIsEditing;
export const selectSubsidiaryFormIsEditing = createSelector(selectState, state => getSubsidiaryFormIsEditing(state));


export const {
	selectSlice: selectAvailableRolesForCurrentSubsidiarySlice,
	selectEntity: selectAvailableRolesForCurrentSubsidiary,
	selectIsLoading: selectAvailableRolesForCurrentSubsidiaryIsLoading,
	selectError: selectAvailableRolesForCurrentSubsidiaryError
} = createEntitySliceSelectors(createSelector(selectState, state => state.availableRolesForCurrentSubsidiary));

export const {
	selectEntity: selectSubsidiaryUserDelegations,
	selectIsLoading: selectSubsidiaryUserDelegationsIsLoading,
	selectError: selectSubsidiaryUserDelegationsError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryUserDelegations));

export const {
	selectEntity: selectSubsidiaryUserDelegationsForm,
	selectIsLoading: selectSubsidiaryUserDelegationsFormIsLoading,
	selectError: selectSubsidiaryUserDelegationsFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryUserDelegationsForm));

export const {
	selectEntity: selectSubsidiaryUserInactivityForm,
	selectIsLoading: selectSubsidiaryUserInactivityFormIsLoading,
	selectError: selectSubsidiaryUserInactivityFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryUserInactivityForm));
